export default "__VITE_ASSET__C5qYVh6x__"